export default __webpack_public_path__ + "assets/images/Alert-a7c94a9b7bb92c8d9219c1f7803a81ef.svg";